<div mat-dialog-title class="modal-title">
  <mat-icon>bookmark_add</mat-icon>
  <span>{{ editMode ? 'Editar categoría' : 'Nueva categoría' }}</span>
  <mat-icon class="close-button" (click)="confirmCloseModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  @if (isLoadingCategory) {
    <div class="loading-page">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  } @else {
    <div class="thumbnail" (click)="categoryThumbnail.click()">
      @if (!currentThumbnail && !imageToUploadSrc) {
        <div class="hint">
          <mat-icon> add_photo_alternate </mat-icon>
          <span> Imagen 16 : 9 </span>
        </div>
      }
      @if (currentThumbnail && !imageToUploadSrc) {
        <img [src]="currentThumbnail" />
      }
      @if (imageToUploadSrc) {
        <img [src]="imageToUploadSrc" />
      }
      <input
        #categoryThumbnail
        type="file"
        name="categoryThumbnail"
        id="categoryThumbnail"
        class="categoryThumbnail"
        accept=".jpg, .png"
        (change)="onSelectImage($event)"
      />
    </div>
    <form [formGroup]="categoryForm" class="row">
      <div class="col-12">
        <div class="form-control hidden">
          <mat-slide-toggle color="primary" formControlName="hidden"> ¿Ocultar categoría? </mat-slide-toggle>
        </div>
      </div>
      <div class="col-12">
        <div class="form-control">
          <mat-form-field color="primary" appearance="outline">
            <mat-label>Nombre de la categoría</mat-label>
            <input matInput type="text" placeholder="Nombre de la categoría" formControlName="name" name="categoryName" autocomplete="off" />
            <mat-error> Nombre de la categoría requerido </mat-error>
          </mat-form-field>
        </div>
      </div>
      @if (currentCategories.length) {
        <div class="col-12 hint">
          <div class="form-control">
            <mat-form-field color="primary" appearance="outline">
              <mat-label>¿En qué posición quieres que aparezca?</mat-label>
              <mat-select placeholder="Selecciona una" formControlName="position" name="categoryPosition" autocomplete="off">
                @for (category of currentCategories; track category; let i = $index) {
                  <mat-option [value]="i">
                    Posición {{ i + 1 }}:
                    @if (currentPosition === i) {
                      <span> Posición actual </span>
                    } @else {
                      <span> En vez de "{{ category.name }}" </span>
                    }
                  </mat-option>
                }
                <mat-option [value]="currentCategories.length"> Al final </mat-option>
              </mat-select>
              <mat-hint> Si no seleccionas una, por defecto se mostrará de primera </mat-hint>
            </mat-form-field>
          </div>
        </div>
      }
      <div class="col-12">
        <div class="upload-files">
          <span>Sube recursos para esta categoría</span>
          <enfaf-dropzone
            [acceptMultiple]="true"
            [acceptLimit]="10"
            [acceptBigFiles]="true"
            filesToAccept="*"
            (filesDropped)="onDroppedAttachments($event)"
          >
          </enfaf-dropzone>
        </div>
      </div>
      @if (currentAttachments.length) {
        <div class="col-12 remote-attachments">
          <enfaf-remote-attachments
            [remoteAttachments]="currentAttachments"
            title="Recursos existentes de esta categoría"
            [isDeletingRemoteAttachment]="isDeletingRemoteAttachment"
            (onDeleteRemoteAttachment)="onDeleteRemoteAttachment($event)"
          >
          </enfaf-remote-attachments>
        </div>
      }
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button color="primary" (click)="confirmCloseModal()"> Cerrar </button>
  <button mat-flat-button color="primary" (click)="saveCategory()" [disabled]="categoryForm.invalid || isSavingCategory">
    @if (!isSavingCategory) {
      <span>Guardar</span>
    } @else {
      <mat-spinner class="white-spinner"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
